<template>
  <div>
    <div class="topBox"></div>
    <div class="mark">
      <i class="iconfont icon-educesuan-icon"></i>
    </div>
    <p class="warn">额度测算中</p>
    <div class="tip">
      <p>您的融资申请已提交到资金方，审批结果需要</p>
      <p>一定时间，请您耐心等待</p>
    </div>
  </div>
</template>

<script>
/**
 * 进这个页面一定是已经成功了
 */

import { checkStatus } from './mixin';

export default {
  name: 'CaculateQuata',
  mixins: [checkStatus],
  beforeCreate() {
    document
      .querySelector('#app')
      .setAttribute('style', 'background-color:#fff');
  },
  beforeDestroy() {
    document.querySelector('#app').removeAttribute('style');
  },
};
</script>
<style scoped>
.topBox {
  width: 100%;
  height: 130px;
}
.mark i {
  color: #f55348;
  font-size: 60px;
}
.warn {
  color: #1c2438;
  font-size: 17px;
  font-size: 700;
  text-align: center;
}
.tip {
  width: 345px;
  height: 60px;
  margin: 0 auto;
  margin-top: 8px;
  color: #9ea7b4;
  font-size: 14px;
  text-align: center;
}
.buttonShell {
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  padding-right: 15px;
  padding-left: 15px;
}
</style>
